let NODE_ENV = window.XINPOC_DISPATCH_CONFIG.isProject;
let title = {
  towway: "two way direct",
  HPYJ: "HPYJ Plateforme de répartition",
  yuantong: "Console de répartition",
  chunsheng: "Console de répartition",
  TALK2ME: "Plateforme de répartition Web",
  wanlian: "Répartiteur d'interphone CAC",
  EuroNews:"WOUXUN Global",
  quansheng:"QUESUM",
};
let voice_title = {
  XiamenGuanhe:"Plateforme d'interphonie, service dédié, pour une interphonie plus efficace.",
  wanlian: "Votre sécurité, notre priorité",
}
let conpanyname = {
  chunsheng:"Copyright © 2025 Poclink Radios. All Rights Reserved.",
  XiamenGuanhe:"Glohe Communication Technology(Xiamen) Co.,Ltd.",
  TALK2ME: "Talk2Me Social Inc. (832)880-0000",
  wanlian: "CONGO ASTRAL COMPANY",
  EuroNews: "WOUXUN COMMUNICATIONS LIMITED",
}

let versions = {
  EuroNews:'V1.00.00'
}
module.exports = {
  language: {
    name: 'Anglais',
    title: 'langue',
  },

  about: {
    title: title[NODE_ENV] || "Répartiteur d'interphone mondial",
    conpanyname: conpanyname[NODE_ENV] || 'Shenzhen Bonard Information Technology Co., Ltd.',
    version:versions[NODE_ENV] || "v1.6.2"
  },
  login: {
    account: 'Entrez votre compte de connexion',
    password: 'entrer le mot de passe',
    installationServices: 'Installer les services vocaux',
    rememberme: 'souviens-toi de moi',
    Login: 'Se connecter'
  },
  message: {
    loginAccountTips: 'Le compte de connexion ne peut pas être vide',
    loginPasswordTips: 'le mot de passe ne peut pas être vide',
    usernamePasswordTips: "Nom d'utilisateur ou mot de passe incorrect",
    loginsuccessful: 'connexion réussie',
    accountNumbers: 'Le compte ne peut saisir que des chiffres !',
    noDispatcher: "La connexion a échoué, le compte n'est pas un répartiteur !",
    accountNotpresent: "Le compte n'existe pas !",
    LoginAbnormal: 'Exception de connexion, veuillez réessayer !',
    voiceServiceNotInstalled: 'Veuillez installer le service vocal si installé, veuillez actualiser le navigateur !',
    Videocallinprogress: 'Appel vidéo en cours !',
    Voicecallinprogress: 'Appel vocal en cours !',
    Youhavebeenclosedforspeaking: 'Vous avez été désactivé pour avoir parlé !',
    tctemporarygroup: 'Êtes-vous sûr de vouloir actualiser et quitter le groupe temporaire ?',
    Doyouwanttologout: 'Voulez-vous vous déconnecter ?',
    prompt: 'indice',
    Nonetworklink: 'pas de connexion internet',
    deletedGro: 'Ce groupe a été supprimé et ne peut plus être utilisé !',
    Pleaseselectthedesired: 'Veuillez sélectionner le champ requis',
    deletedGroUsers: 'Utilisateur!',
    Voicecallfunction: 'Veuillez d’abord activer la fonction d’appel vocal sur la plateforme de gestion !',
    Alreadytemporary: "Déjà dans un groupe temporaire impossible d'appeler !",
    Onlysupports: 'Prend uniquement en charge les appels vocaux vers un seul utilisateur !',
    Enablevoicecalls: "Cet utilisateur n'a pas activé la fonction d'appel vocal sur la plateforme de gestion !",
    Oncall: 'Impossible de créer pendant un appel !',
    Shaketodeath: 'Les morts tremblants ne peuvent pas créer',
    Shaketodeath2: 'Shaking Dead ne peut pas changer de groupe',
    createregiongroups: 'Vous ne pouvez créer que 3 groupes régionaux maximum !',
    temporarygroupsnoadd: 'Déjà dans un groupe temporaire ne peut pas être créé !',
    haleDispatcherGroupUser: 'Seuls les membres du groupe des répartiteurs peuvent être forcés',
    TemporaryGroupNoHale: 'Groupe temporaire ne forcez pas la traction !',
    Groupcallfailure: "Échec de l'appel de groupe",
    Exitsuccessfully: 'sortie réussie !',
    Usernotonline: "L'utilisateur est hors ligne !",
    Theotherpartyisbusy: "L'autre partie est occupée !",
    Callfailed: "L'appel a échoué !",
    Theotherpartyhashungup: "L'autre partie a raccroché !",
    Networkconnectionfailed: 'La connexion réseau a échoué, effacez-la et réessayez plus tard',
    Callended: 'appel terminé !',
    Accountpassworderror: 'erreur de mot de passe du compte',
    Arrears: 'en retard',
    Accountdoesnotexist: "le compte n'existe pas",
    Permissionerror: "erreur d'autorisation",
    AccountInfoChange: 'Les informations du compte ont changé',
    Configuration: "Erreur d'informations de configuration",
    accountOtherlogins: 'Le compte est déjà connecté ailleurs !',
    Accountlogintimeout: 'La connexion au compte a expiré',
    Networkconnectionfailure: 'La connexion réseau a échoué',
    Thenetworkisreconnecting: 'Le réseau se reconnecte',
    Addinggroupfailed: 'Impossible de rejoindre le groupe',
    Addgrouprequesttimeout: "La demande d'adhésion au groupe a expiré",
    Singlecallfailure: "échec d'un appel unique",
    Failedtojointhegroup: "Impossible de rejoindre le groupe [erreur d'autorisation]",
    Failedtojointhegroup2: "Impossible de rejoindre le groupe [n'existe pas]",
    Failedtojointhegroup3: "Impossible de rejoindre le groupe [Expiré]",
    Failedtojointhegroup4: 'Impossible de rejoindre le groupe [limite de quota]',
    Failedtojointhegroup5: "Échec de la connexion au groupe [l'objet valide est vide]",
    noSnatchingwheat: "Il n'est pas permis de récolter du blé plusieurs fois dans un court laps de temps.",
    noRemoteclosureSnatchingwheat: "Il n'est pas permis de saisir des microphones à distance lorsqu'ils sont fermés.",
    Failedtograbthewheat: "Échec de l'application de la mise au point audio lors de la saisie des microphones",
    Grabbingwheattimeout: "Délai d'attente expiré lors de la réception de la réponse du micro",
    Failedtoopenrecordingdevice: "Impossible d'ouvrir le périphérique d'enregistrement",
    Accountlocked: 'le compte est verrouillé',
    Terminallocked: 'Le terminal est verrouillé',
    Machinecardlocked: 'la carte est verrouillée',
    Noaccountinformationconfigured: 'Aucune information de compte configurée',
    Successfullysaved: 'Enregistré avec succès !',
    Successfullysethost: "Définir l'hôte avec succès !",
    Successfullydeleted: 'supprimé avec succès !',
    Successfullyadded: 'Ajouté avec succès!',
    Successfullyremoved: 'Supprimé avec succès !',
    update_successfully: 'mise à jour terminée',
    Successfullymodified: 'Modifié avec succès !',
    oldpassworderror: "erreur d'ancien mot de passe",
    Parametererror: 'Erreur de paramètre',
    Pleaseselecttheuseryouwanttoadd: "Veuillez sélectionner l'utilisateur à ajouter !",
    Addingfailed: "Échec de l'ajout, la liste des utilisateurs non présents dans le groupe est vide !",
    Pleaseselectuserremoved: "Veuillez sélectionner l'utilisateur à supprimer !",
    Removalfailed: 'La suppression a échoué. La liste des utilisateurs dans le groupe est vide !',
    Prioritysetsuccessfully: 'Priorité définie avec succès',
    Pleaseselectastartandendtime: 'Veuillez sélectionner une heure de début et de fin',
    endTimeNoStarttime: "L'heure de fin ne peut pas être antérieure à l'heure de début",
    Thestartandendtimesmustbeonthesameday: "L'heure de début et l'heure de fin doivent être le même jour",
    RedefineCustomization: 'Le nombre de points dans la zone personnalisée est inférieur à 3, veuillez redessiner !',
    Unabletocreatetemporarygroup: "Il n'y a actuellement aucun membre en ligne incapable de créer un groupe temporaire !",
    Pleaseenteroldpassword: "Veuillez saisir l'ancien mot de passe",
    Pleaseenteranewpassword: 'Veuillez entrer un nouveau mot de passe',
    Confirmnewpassword: 'Confirmer le nouveau mot de passe',
    noSamePassword: "L'ancien mot de passe ne peut pas être cohérent avec le nouveau mot de passe !",
    noSamePasswordTow: 'Les mots de passe saisis deux fois sont incohérents !',
    pleaseenterpasswordagain: 'veuillez saisir à nouveau le mot de passe',
    Successfullyprocessed: 'Traité avec succès',
    voice_title: voice_title[NODE_ENV] || ""
  },
  search: 'recherche',
  users: 'utilisateur',
  refund: 'retour',
  Loadingdesperately: 'Chargement désespéré',
  Speaking: 'parler...',
  Iamspeaking: 'Je parle...',
  communicatebytelephone: 'conversation vocale',
  call: 'interphone',
  hale: 'forte traction',
  Forceddemolition: 'Démolition',
  confirm: 'Bien sûr',
  cancel: 'Annuler',
  dispatchIntercom: 'interphone de répartition',
  allGroups: 'tous les groupes',
  fixedGroup: 'groupes fixes',
  regionalGroup: 'groupe régional',
  filter: 'filtre',
  all: 'tous',
  online: 'en ligne',
  offline: 'hors ligne',
  groupUser: 'groupe/utilisateur',
  enter: 'Entrer',
  edit: 'modifier',
  voiceIntercom: 'Interphone vocal',
  baseStationSwitch: 'commutateur de station de base',
  gpsSwitch: 'commutateur GPS',
  viewHistoricalTrack: 'Voir la piste historique',
  startingtime1: 'Heure de début',
  selectionPeriod: "Sélectionnez l'heure",
  startingTime: 'Heure de début',
  Pleaseselectadateandtime: 'Veuillez sélectionner une heure de début',
  EndTime: 'Fin des temps',
  Pleaseselectanendtime: 'Veuillez sélectionner une heure de fin',
  selectDate: 'sélectionner la date',
  SelectStartTime: "sélectionner l'heure de début",
  Now: 'maintenant',
  Sure: 'Bien sûr',
  Closure: 'fermeture',
  editArea: "zone d'édition",
  deleteArea: 'supprimer la zone',
  Areyousuretosavethefence: 'Êtes-vous sûr de vouloir sauver la clôture ?',
  deleteLocalgroup: 'Êtes-vous sûr de vouloir supprimer le groupe de zones ?',
  pleaseselectaregion: 'Veuillez d’abord entourer la zone de la barre de sélection !',
  doubleclicktocreate: 'Double-cliquez pour créer',
  doubleclick: 'double-cliquez',
  Createregionalgroups: 'Créer des groupes régionaux',
  groupName: 'nom du groupe',
  Pleaseenterthegroupname: 'Veuillez saisir un nom de groupe',
  pleaseenteragroupname: 'Veuillez saisir le nom du groupe (composé de 2 à 15 chiffres chinois et anglais)',
  groupnameTips: 'Le nom du groupe est composé de 2 à 15 chiffres chinois et anglais',
  pleaseenteragroupnameTips: 'Composé de 2 à 15 chiffres chinois et anglais',
  selectGroup: 'groupe sélectionné',
  Pinnedingroupusers: 'épinglé dans les utilisateurs du groupe',
  TemporaryGroup: 'Utilisateurs temporaires dans le groupe',
  Usernotingroup: 'utilisateur non membre du groupe',
  userImei: 'Utilisateur/IMEI',
  Pleaseselectauser: 'Veuillez sélectionner un utilisateur',
  Create: 'créer',
  Cancel: 'Annuler',
  groupEdit: 'édition de groupe',
  usersingroup: 'utilisateurs du groupe',
  UsernameImei: "Nom d'utilisateur/IMEI",
  userName: "nom d'utilisateur",
  noData: 'Aucune donnée',
  removeselectedusers: 'supprimer les utilisateurs sélectionnés',
  Removeall: 'supprimer tout',
  Addtheselecteduser: 'Ajouter les utilisateurs sélectionnés',
  Addall: 'ajouter tout',
  Save: 'sauvegarder',
  selectUser: "sélectionner l'utilisateur",
  Edittakeseffect: 'la modification prend effet',
  UserManagement: 'Gestion des utilisateurs',
  Userpriority: 'priorité utilisateur',
  levelone: 'niveau un',
  Secondary: 'niveau deux',
  Levelthree: 'niveau deux',
  Levelfour: 'Niveau quatre',
  Fifthgrade: 'Niveau cinq',
  Editstakeeffectimmediately: 'Les modifications prennent effet immédiatement',
  Setmoderator: "définir l'hôte",
  SelectHost: "choisir l'hôte",
  Host: 'hôte',
  Pleasechoose: "s'il vous plaît choisir",
  Deletemoderator: "supprimer l'hôte",
  Setuphost: 'Un seul utilisateur peut être défini comme hôte',
  Pleaseselectacall: 'Veuillez choisir ce que vous souhaitez appeler',
  Waitingforanswering: "Attendez que l'autre partie réponde à la voix",
  Inviteyoutovoicecall: 'vous invite à un appel vocal',
  callingusers: "Veuillez sélectionner l'utilisateur à appeler",
  Forcedpullusers: "Veuillez sélectionner l'utilisateur à appeler",
  Forceddismantlingusers: "Veuillez sélectionner l'utilisateur qui doit être démoli",
  SearchLocation: 'emplacement de recherche',
  Show: 'montrer',
  Hide: 'cacher',
  Default: 'défaut',
  Satellite: 'satellite',
  Roadconditions: 'conditions routières',
  Toolbox: 'boîte à outils',
  Ranging: 'allant de',
  Mark: 'marque',
  Broadcast: 'diffuser',
  EnableBroadcastGroup: "Veuillez d'abord permettre au groupe de recevoir les diffusions",
  textBroadcast: 'diffusion de texte',
  Hasbeensent: 'A été envoyé',
  textBroadcastContent: 'Veuillez saisir le contenu du texte diffusé (pas plus de 50 caractères)',
  pleaseentertextbroadcast: 'veuillez saisir le texte diffusé',
  Send: 'envoyer',
  voiceBroadcast: 'diffusion vocale',
  Clicktorecordvoicebroadcast: 'Cliquez pour enregistrer la diffusion vocale',
  Pleaserecordthevoicebroadcast: 'Cliquez pour enregistrer la diffusion vocale',
  RecordingTime: "La durée d'enregistrement ne peut pas être inférieure à 1 seconde",
  Broadcaster: 'Diffuseur',
  BroadcastTime: 'heure de diffusion',
  listento: 'écouter',
  Warningmessage: "message d'avertissement",
  AlarmHistory: "Pour plus de messages d'avertissement, veuillez consulter l'historique",
  Name: 'nom',
  Address: 'adresse',
  Time: 'temps',
  Check: 'Vérifier',
  State: 'État',
  Unprocessed: 'non transformé',
  DealWith: 'traiter avec',
  delete: 'supprimer',
  PTTbuttondisplay: 'Affichage du bouton PTT',
  SOSalarmsound: "Son d'alarme SOS",
  Fencealarmsound: "son d'avertissement de clôture",
  Motiontrajectorybinding: 'Voie de mouvement pour route',
  Changepassword: 'Voie de mouvement pour route',
  Logoutoflogin: 'se déconnecter',
  Dataanalysis: 'analyse des données',
  Statisticstoday: "Les statistiques aujourd'hui",
  Currentonlineusers: 'Utilisateurs en ligne actuels',
  Totalnumberofusers: 'total des utilisateurs',
  Fencerecord: 'record de clôture',
  SOSrecord: 'Enregistrement SOS',
  recordingrecord: 'enregistrement audio',
  Grouponlineusers: "groupe d'utilisateurs en ligne",
  Comparison: "Comparaison du nombre d'utilisateurs en ligne en 7 jours",
  warningcomparison: 'Comparaison des alertes précoces à 30 jours',
  Fencewarning: 'avertissement de clôture',
  SOSwarning: 'Alerte SOS',
  OldPassword: 'Ancien mot de passe',
  NewPassword: 'Nouveau mot de passe',
  ConfirmPassword: 'Confirmez le mot de passe',
  consists: 'Composé de 6 à 16 lettres et chiffres',
  startingpoint: 'point de départ',
  totallength: 'longueur totale',
  ico: 'ico',
  date: 'date',
  Targeting: 'Ciblage',
  Basestationpositioning: 'Positionnement de la station de base',
  BeidouGPS: 'Beidou/GPS',
  direction: 'direction',
  altitude: 'altitude',
  Speed: 'Vitesse (KM/H)',
  warmreminder: " Rappel : ces données proviennent d'un tiers et peuvent contenir des erreurs. Elles sont fournies à titre indicatif uniquement.",
  Iconselection: "Sélection d'icônes",
  pleaseentername: 'Veuillez entrer le nom',
  changeicon: "Changer d'icône",
  Universal: 'Universel',
  policesecurity: 'sécurité policière',
  Firefighting: 'Lutte contre les incendies',
  Chemicalindustry: 'Industrie chimique',
  other: 'autre',
  save: 'Sauvegarder',
  close: 'Fermer',
  viewtag: "Voir l'étiquette",
  addtag: 'Ajouter une balise',
  Supportsaddingamaximum: "Prend en charge l'ajout d'un maximum de 10 icônes",
  Imageformaterror: "Erreur de format d'image",
  uploadedimage: "La taille de l'image téléchargée ne peut pas dépasser 5 Ko !",
  uploadsuccessful: 'Téléchargement réussi',
  uploadfailed: 'Téléchargement réussi',
  uploadfailedimage: 'Échec du téléchargement : la taille maximale en pixels de l’image est de 25×25 !',
  Successfuloperation: 'Opération réussie',
  operationfailed: "l'opération a échoué",
  Editmark: "Marque d'édition",
  Pleaseselecttheiconyouwanttodelete: "Veuillez sélectionner l'icône que vous souhaitez supprimer",
  successfullydeleted: 'supprimé avec succès',
  failedtodelete: 'échec de suppression',
  north: 'nord',
  South: 'Sud',
  West: 'Ouest',
  East: 'Est',
  truenorth: 'vrai nord',
  duesouth: 'plein sud',
  duewest: 'plein ouest',
  Zhengdong: 'Zhengdong',
  partial: 'partiel',
  historyrecord: 'record historique',
  group: 'groupe',
  pleaseselectagroup: 'Veuillez sélectionner un groupe',
  sender: 'expéditeur',
  Pleaseselectuser: "Veuillez sélectionner l'utilisateur",
  Sendtime: "Heure d'envoi",
  startrange: 'plage de départ',
  endrange: 'fin de gamme',
  startdate: 'date de début',
  Startingtime: 'Heure de début',
  enddate: 'date de fin',
  to: 'à',
  Clear: 'Clair',
  Confirm: 'Confirmer',
  state: 'État',
  Pleaseselectastatus: 'Veuillez sélectionner un statut',
  Processed: 'Traité',
  Processor: 'Processeur',
  processtime: 'temps de traitement',
  serialnumber: 'numéro de série',
  operate: 'fonctionner',
  ViewSOSlocation: "Afficher l'emplacement SOS",
  Back: 'Dos',
  Warmreminder: " Rappel : ces données proviennent d'un tiers et peuvent contenir des erreurs. Elles sont fournies à titre indicatif uniquement.",
  SOSalarmsintemporarygroupsarenotrecorded: 'Les alarmes SOS dans les groupes temporaires ne sont pas enregistrées.',
  Pleaseselectatype: 'Veuillez sélectionner un type',
  deleted: 'supprimé',
  next: 'suivant',
  Tobeprocessed: 'À traiter',
  dealwith: 'traiter avec',
  alreadydispatched: 'Déjà expédié',
  temporarygroup: 'groupe temporaire',
  NortheasternHemisphere: 'Hémisphère Nord-Est',
  northwesternhemisphere: 'hémisphère nord-ouest',
  SoutheasternHemisphere: 'Hémisphère sud-est',
  southwesternhemisphere: 'Hémisphère sud-est',
  Nolocationtrack: 'Aucune trace de localisation',
  Latitudeandlongitude: 'Latitude et longitude',
  Reportingtime: 'Heure du rapport',
  Positioningtime: 'Temps de positionnement',
  Alarminformation: "Informations d'alarme",
  AlarminformationTips: "Pour plus de messages d'alarme, veuillez consulter les enregistrements d'historique",
  initiatesos: 'initier SOS',
  Forcedvideo: 'Vidéo forcée',
  videocall: 'appel vidéo',
  Videopostback: 'Postback vidéo',
  leave: 'partir',
  Enter: 'Entrer',
  fence: 'clôture',
  newgroup: 'nouveau groupe',
  Joingroup: 'Rejoindre le groupe',
  Thegroupnamealreadyexistspleasereenterit: 'Le nom du groupe existe déjà, veuillez le saisir à nouveau.',
  Groupcreatedsuccessfully: 'Groupe créé avec succès',
  Groupcreationfailedpleasecreateagain: 'La création du groupe a échoué, veuillez la créer à nouveau !',
  Pleaseenterthegrouppassword: 'Veuillez saisir le mot de passe du groupe',
  Thegrouppasswordyouenterediswrong: 'Le mot de passe de groupe que vous avez saisi est incorrect',
  Grouppassword: 'Mot de passe du groupe',
  Dissolve: 'Dissoudre',
  Exit: 'Sortie',
  Disbandselforganizedgroup: 'Dissoudre le groupe auto-organisé',
  Exittheselfcreatedgroup: 'Quitter le groupe auto-créé',
  ExiDissolvetheselfestablishedgroupt: 'Êtes-vous sûr de vouloir dissoudre le groupe auto-construit ?',
  Exitselfbuiltgroup: 'Êtes-vous sûr de vouloir quitter le groupe auto-construit ?',
  Grouptransfer: 'Transfert de groupe',
  Theusersselfbuiltgroupfunctionisnotopened: "La fonction de groupe auto-créée par les utilisateurs n'est pas ouverte",
  Createfence: 'Créer une clôture',
  Editfence: 'Modifier la clôture',
  electricfence: 'clôture électrique',
  Electronicfencelist: 'Liste de clôture électronique',
  fencename: 'nom de la clôture',
  efficient: 'efficace',
  Invalid: 'Invalide',
  Forbidden: 'Interdit',
  Noentry: 'Entrée interdite',
  Pleasesearchorselfselectthefencedareafirst: 'Veuillez d’abord entourer la zone de la barre de sélection !',
  Areyousureyouwanttodeletetheelectronicfence: 'Êtes-vous sûr de vouloir supprimer la clôture électronique ?',
  Triggermode: 'Mode de déclenchement',
  timesetting: "réglage de l'heure",
  Pleaseenterthefencename: 'Veuillez saisir le nom de la clôture',
  tipsItconsists: ' Il se compose de 1 à 15 caractères chinois, de chiffres, de lettres et de traits de soulignement et ne peut pas commencer par un trait de soulignement.',
  tipsItconsistsName: 'Le nom de la clôture est composé de 1 à 15 caractères chinois, de chiffres, de lettres et de traits de soulignement et ne peut pas commencer par un trait de soulignement.',
  Pleaseselectamethodofentryandexit: "Veuillez sélectionner une méthode d'entrée et de sortie",
  Pleaseselectatleastoneday: 'Veuillez sélectionner au moins un jour',
  Notinfenceusers: 'Pas dans les utilisateurs de clôture',
  Usersonthefence: 'Les utilisateurs indécis',
  Validdate: 'Date de validité',
  Validperiod: 'Période de validité',
  Selecttimerange: 'Sélectionnez la plage horaire',
  Monday: 'Lundi',
  Tuesday: 'Mardi',
  Wednesday: 'Mercredi',
  Thursday: 'Jeudi',
  Friday: 'Vendredi',
  Saturday: 'Samedi',
  Sunday: 'Dimanche',
  Createdsuccessfully: 'Créé avec succès',
  Thefencenameisduplicated: 'Le nom de la clôture est dupliqué, veuillez le modifier et réessayer.',
  Ifnotselected: "Si cette option n'est pas sélectionnée, la valeur par défaut est valide en permanence.",
  FenceEdit: 'ClôtureModifier',
  Removalfailedfence: 'La suppression a échoué, la liste des utilisateurs de clôture est vide !',
  Failedtoaddfence: "Impossible d'ajouter la liste des utilisateurs non présents dans la clôture, elle est vide !",
  Outofboundsrecord: 'enregistrement des frontières',
  Outofboundstype: 'enregistrement des frontières',
  Pleaseselectausername: "Veuillez sélectionner un nom d'utilisateur",
  Pleaseselecttriggermethod: 'Veuillez sélectionner la méthode de déclenchement',
  Crossborderdate: 'Date transfrontalière',
  currentrecord: 'record actuel',
  Triggertime: 'Heure de déclenchement',
  Pleaseselectafencename: 'Veuillez sélectionner un nom de clôture',
  Releasetime: 'Heure de sortie',
  Batchdownload: 'Téléchargement par lots',
  Recordingplayback: "Lecture d'enregistrement",
  download: 'télécharger',
  Areyousureyouwant: "Êtes-vous sûr de vouloir télécharger l'enregistrement sélectionné ?",
  Record: 'Enregistrer',
  Pleaseselecttherecording: "Veuillez sélectionner l'enregistrement que vous souhaitez télécharger",
  downloadsuccessful: 'téléchargement réussi',
  Voiceaudio: 'Audio vocal',
  text: 'texte',
  voice: 'voix',
  Doubleclicktocreate: 'Double-cliquez pour créer',
  Doubleclicktosave: 'Double-cliquez pour enregistrer',
  outofboundsperson: 'personne hors limites',
  temporarygroupTow: 'groupe temporaire',
  Theotherpartyhasnoanswer: "L'autre partie n'a pas de réponse !",
  sosrecord: 'Enregistrement SOS',
  UnhandledSOSexists: 'Un SOS non géré existe',

  RealTimeVideo: 'Vidéo en direct',
  ForceVideo: 'Forcer la traction vidéo/retour vidéo',
  VideoCall: 'Appel vidéo',
  CurrentlyNoRealTimeVideo: "Il n'y a actuellement aucune vidéo en direct",
  VideoUserList: 'Liste des utilisateurs de vidéos',
  Filter: 'filtre:',
  All: 'tous',
  Online: 'En ligne',
  Offline: 'Hors ligne',
  GroupUser: 'Groupe/Utilisateur',
  ForceVideos: 'Vidéo de traction forte',
  PleaseSelectTheUserWhoNeedsxxx: 'Veuillez sélectionner un utilisateur !',
  TheDispatcherCannotForceIt: 'Le répartiteur ne peut pas le forcer !',
  VoiceCallInProgress: 'En appel vocal !',
  PleaseActivateTheVideoServiceAndVideoCallFunctionOnTheManagementPlatformFirst: "Veuillez d'abord activer le service vidéo et activer la fonction d'appel vidéo dans la plateforme de gestion !",
  PleaseEnableTheVideoCallFunctionOnTheManagementPlatformFirst: 'Veuillez d’abord activer la fonction d’appel vidéo dans la plateforme de gestion !',
  UserIsNotOnline: "L'utilisateur est hors ligne",
  OnlySupportsInitiatingVideoCallsToASingleUser: "Prend uniquement en charge le lancement d'appels vidéo vers un seul utilisateur",
  ThisUserHasNotActivatedTheVideoServiceOnTheManagementPlatform: "Cet utilisateur n'a pas activé le service vidéo dans la plateforme de gestion !",
  ThisUserHasNotEnabledTheVideoCallFunctionOnTheManagementPlatform: "Cet utilisateur n'a pas activé la fonction d'appel vidéo dans la plateforme de gestion !",
  VideoCallInProgress: 'Appel vidéo en cours !',
  CannotCallTheTerminalThatIsTransmittingVideo: "Impossible d'appeler le terminal qui transmet la vidéo",
  TheOtherPartyIsBusy1: "L'autre partie est occupée",
  ThisUserHasNotEnabledTheForceVideoFunctionOnTheManagementPlatform: "Cet utilisateur n'a pas activé la fonction vidéo forcée dans la plateforme de gestion !",
  CannotForceTheTerminalThatIsTransmittingVideo: 'Vous ne pouvez pas tirer de force sur le terminal qui télécharge actuellement la vidéo.',
  UserAlreadyExists: "L'utilisateur existe déjà",

  TheOtherPartyInvitedMeToAVideoCall: "L'autre partie vous invite à un appel vidéo...",
  Connecting: 'De liaison...',
  TheOtherPartyHasRejected: "L'autre partie a rejeté",
  TheOtherPartyHasHungUp: "L'autre partie a rejeté",
  TheOtherPartyDidNotAnswer: "L'appelant n'a pas répondu",
  TheOtherPartyIsBusy2: "L'autre partie est occupée !",
  ConnectionInterruptedCallEnded: "La connexion est interrompue, l'appel se termine !",
  AnswerFailed: 'Réponse échouée',
  ConnectionFailed: 'La connexion a échoué',
  exceedFenceMsg:'Le nombre maximal de créations a été dépassé. Veuillez supprimer la clôture et réessayer !',

  userPatrol: {
    searchLable: {
        PlanName: "Nom du projet",
        PatrolUsers: "utilisateurs de Patrol",
        ExecutionResult: "Résultat de l'exécution",
        PatrolTime: "Temps de patrouille",
        PatrolPointName: "Temps de patrouille",
    },
    placeholder: {
        PleaseEnterThePlanMame: "Veuillez saisir le nom du forfait.",
        PleaseEnterThePatrolUser: "Veuillez saisir l'utilisateur de la patrouille.",
        PleaseSelectTheExecutionResult: "Veuillez sélectionner le résultat de l'exécution.",
    },
    tableHeader:{
        PlanName: "Nom du projet",
        patrolPoint: "point de patrouille",
        PatrolUsers: "utilisateurs de Patrol",
        PatrolPointName:"Noms des points de patrouille",
        StartTime: "Heure de début",
        EndTime: "Fin du temps",
        ExecutionResult: "Résultat de l'exécution",
        type:"taper",
        PatrolTime:"Temps de patrouille",
    },
    status: {
        NotStarted:"Pas encore commencé",
        InProgress: "en cours",
        Completed: "Complété",
        MissingPatrol: "Inspection manquée",
        positioning: "position",
        NFC:"NFC",
        Bluetooth: "Bluetooth",
    },
    StartingRange: "Plage de départ",
    EndRange: "Gamme finale",
    ViewDetails:"vérifier les détails",
    PatrolTrajectory: "Route de patrouille",
    patrol:'Patrouille',
    PatrolFailed:"La patrouille a échoué",
    PatrolLog: "Journal de patrouille",
  }
};